import Phaser from 'phaser';
import logger from '@game/system/logger';
import { pauseManager, inputManager, assetManager } from '@game/system';

const managerRegistry = [pauseManager, inputManager, assetManager];

function GameManager() {
	Phaser.Scene.call(this, { key: 'GameManager' });

	this.init = function () {
		logger.debug('GameManager: init');
		this.scene.sendToBack(this.scene.key);
		this.scene.setVisible(false);

		this.events.once('shutdown', () => {
			logger.debug('GameManager: shutdown, disposing managers');
			managerRegistry.forEach((manager) => manager.dispose());
		});

		managerRegistry.forEach((manager) => manager.register(this));
		managerRegistry.forEach((manager) => manager.onInit(this));
	};

	this.create = function () {
		logger.debug('GameManager: create');
		managerRegistry.forEach((manager) => manager.onCreate());
	};

	this.update = function () {
		managerRegistry.forEach((manager) => manager.onUpdate());
	};
}
GameManager.prototype = Object.create(Phaser.Scene.prototype);
GameManager.prototype.constructor = GameManager;

export default GameManager;
